import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const ConnectedAccounts = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      d="M4.99019 6.66654H1.33333C0.6 6.66654 0 7.26654 0 7.99988V10.6665H1.33333V7.99988H4.02021C4.18291 7.60312 4.42536 7.23138 4.74755 6.90918L4.99019 6.66654Z"
      fill="currentColor"
    />
    <path
      clipRule="evenodd"
      d="M4.66667 5.33321H3.33333C2.6 5.33321 2 4.73321 2 3.99988V1.33321C2 0.599878 2.6 -0.00012207 3.33333 -0.00012207H4.66667C5.4 -0.00012207 6 0.599878 6 1.33321V3.99988C6 4.73321 5.4 5.33321 4.66667 5.33321ZM4.66667 1.33321H3.33333V3.99988H4.66667V1.33321Z"
      fill="currentColor"
      fillRule="evenodd"
    />
    <path
      d="M8.04738 10.209C7.52668 10.7297 6.68246 10.7297 6.16176 10.209C5.64106 9.68832 5.64106 8.8441 6.16176 8.3234L7.10457 7.38059L6.16176 6.43778L5.21895 7.38059C4.17755 8.42199 4.17755 10.1104 5.21895 11.1518C6.26035 12.1932 7.94879 12.1932 8.99019 11.1518L9.933 10.209L8.99019 9.26621L8.04738 10.209Z"
      fill="currentColor"
    />
    <path
      d="M8.99019 5.49497C9.51089 4.97427 10.3551 4.97427 10.8758 5.49497C11.3965 6.01567 11.3965 6.85989 10.8758 7.38059L9.933 8.3234L10.8758 9.26621L11.8186 8.3234C12.86 7.282 12.86 5.59356 11.8186 4.55216C10.7772 3.51076 9.08878 3.51076 8.04738 4.55216L7.10457 5.49497L8.04738 6.43778L8.99019 5.49497Z"
      fill="currentColor"
    />
    <path
      d="M6.63316 8.7948C6.37281 9.05515 6.37281 9.47726 6.63316 9.73761C6.89351 9.99796 7.31562 9.99796 7.57597 9.73761L10.4044 6.90918C10.6648 6.64883 10.6648 6.22673 10.4044 5.96638C10.1441 5.70603 9.72194 5.70603 9.46159 5.96638L6.63316 8.7948Z"
      fill="currentColor"
    />
  </Icon>
));

export default ConnectedAccounts;
